import { ConnectionType } from '../connectors'

export const BACKFILLABLE_WALLETS = [
  ConnectionType.COINBASE_WALLET,
  ConnectionType.WALLET_CONNECT,
  ConnectionType.INJECTED,
]
